const WIDGET_1_DASHBOARD_5_DATA_ITEM = ["1", "2", "3", "4", "5", "6", "15"];
const WIDGET_2_DASHBOARD_5_DATA_ITEM = ["7.1", "7.2", "7.3"];
const WIDGET_3_DASHBOARD_5_DATA_ITEM = ["8", "9", "10", "11", "13"];
const WIDGET_4_DASHBOARD_5_DATA_ITEM = ["17"];
const WIDGET_5_DASHBOARD_5_DATA_ITEM = ["12", "14", "16", "18"];
const WIDGET_6_DASHBOARD_5_DATA_ITEM = ["1", "2", "3", "4", "5", "6", "15"];
const WIDGET_7_DASHBOARD_5_DATA_ITEM = ["1", "2", "3", "4", "5", "6", "15"];
const WIDGET_8_DASHBOARD_5_DATA_ITEM = ["7.1", "7.2", "7.3"];
const WIDGET_9_DASHBOARD_5_DATA_ITEM = ["7.1", "7.2", "7.3"];
const WIDGET_10_DASHBOARD_5_DATA_ITEM = ["8", "9", "10", "11", "13"];
const WIDGET_11_DASHBOARD_5_DATA_ITEM = ["8", "9", "10", "11", "13"];
const WIDGET_12_DASHBOARD_5_DATA_ITEM = ["17"];
const WIDGET_13_DASHBOARD_5_DATA_ITEM = ["17"];
const WIDGET_14_DASHBOARD_5_DATA_ITEM = ["12", "14", "16", "18"];
const WIDGET_15_DASHBOARD_5_DATA_ITEM = ["12", "14", "16", "18"];
const WIDGET_16_DASHBOARD_5_DATA_ITEM = "hPrLP02dias";
const WIDGET_17_DASHBOARD_5_DATA_ITEM = "hPrLP02dias";

const months = [
  "jan",
  "feb",
  "mar",
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sep",
  "oct",
  "nov",
  "dec",
];

export {
  months,
  WIDGET_1_DASHBOARD_5_DATA_ITEM,
  WIDGET_2_DASHBOARD_5_DATA_ITEM,
  WIDGET_3_DASHBOARD_5_DATA_ITEM,
  WIDGET_4_DASHBOARD_5_DATA_ITEM,
  WIDGET_5_DASHBOARD_5_DATA_ITEM,
  WIDGET_6_DASHBOARD_5_DATA_ITEM,
  WIDGET_7_DASHBOARD_5_DATA_ITEM,
  WIDGET_8_DASHBOARD_5_DATA_ITEM,
  WIDGET_9_DASHBOARD_5_DATA_ITEM,
  WIDGET_10_DASHBOARD_5_DATA_ITEM,
  WIDGET_11_DASHBOARD_5_DATA_ITEM,
  WIDGET_12_DASHBOARD_5_DATA_ITEM,
  WIDGET_13_DASHBOARD_5_DATA_ITEM,
  WIDGET_14_DASHBOARD_5_DATA_ITEM,
  WIDGET_15_DASHBOARD_5_DATA_ITEM,
  WIDGET_16_DASHBOARD_5_DATA_ITEM,
  WIDGET_17_DASHBOARD_5_DATA_ITEM,
};
